module.exports = __webpack_public_path__ + "img/icon-setting-biometric.016331d9.svg";